import { useFadeIn } from '../../../hooks/useFadeIn';

export default function Benefits() {
  const { ref, isVisible } = useFadeIn({ threshold: 0.1 });

  const benefits = [
    {
      number: '01',
      title: '従業員の活力向上',
      description: '安心して働ける環境が、組織の信頼感とやる気を引き出す',
      detail: '満足度改善により生産性が向上'
    },
    {
      number: '02',
      title: '休職・離職の予防',
      description: '不調の兆候を早期にキャッチし、深刻化を防止',
      detail: '休職率を最大40%削減した実績あり'
    },
    {
      number: '03',
      title: '採用コストの圧縮',
      description: '突発的な欠員補充を未然に防ぎ、採用負担を軽減',
      detail: '年間採用コストを平均30%カット'
    },
    {
      number: '04',
      title: '管理部門の負荷軽減',
      description: '対応業務を専門家に分散し、人事・管理職の手を空ける',
      detail: '担当者の業務時間を月平均20時間削減'
    }
  ];

  return (
    <section id="benefits" className="min-h-screen py-24 bg-[#1A3B5C] relative overflow-hidden flex items-center">
      {/* Wave Pattern */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="wave" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
              <path d="M0 50 Q 25 25, 50 50 T 100 50" stroke="#2B5278" fill="none" strokeWidth="2"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#wave)"/>
        </svg>
      </div>

      <div 
        ref={ref}
        className={`max-w-7xl mx-auto px-6 w-full relative transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
            導入による4つの経営メリット
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className={`bg-white rounded-xl p-8 hover:shadow-2xl transition-all duration-700 group cursor-pointer ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="mb-4">
                <span className="text-6xl font-light text-[#FF6B6B]">
                  {benefit.number}
                </span>
              </div>
              
              <h3 className="text-2xl font-bold text-[#1A3B5C] mb-3">
                {benefit.title}
              </h3>
              
              <div className="flex items-center gap-2 mb-4">
                <i className="ri-arrow-right-line text-[#FF6B6B] text-xl"></i>
                <p className="text-base text-gray-700">
                  {benefit.description}
                </p>
              </div>
              
              <p className="text-sm text-gray-500 italic leading-relaxed">
                {benefit.detail}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
